import Vue from 'vue';
import VueGtagPlugin from 'vue-gtag';
import App from './App.vue';
import ModernApp from './ModernApp.vue';
import { Bridge } from './common/bridge';
import router from './router';
import { store } from './store';
import './polyfills';
import DialogPlugin from './plugins/dialog';
import * as Locale from '@/plugins/i18n';
import * as PleasedApi from '@/common/api/api.pleased';
// @ts-ignore - .css module declarations is covered in vite.
import '@/vendor/baguetteBox-js/baguetteBox.min.css';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { OhVuePlugin } from '@/plugins/oh-vue-icon';
import { setupMaintenanceLib } from '@/common/MaintenanceLib';
import * as env from '@/common/environment';
import { logger } from '@/common/api/logger';
import { parseErrorMessage } from '@/common/error';
import { collectWebVitals } from '@/common/rum.utils';
import {
  bindChatbotRouteTracking,
  captureEventException,
  ErrorTrackingEvent,
  initErrorTracking,
} from '@/common/error-tracking';

// Attaches Vue.config.errorHandler via @pleased-npm/error-tracking when DSN is present.
initErrorTracking();
bindChatbotRouteTracking(router);
collectWebVitals();

Vue.config.productionTip = false;
Vue.use(PiniaVuePlugin);
Vue.use(VueQueryPlugin);
Vue.use(OhVuePlugin);
Vue.use(DialogPlugin);
Vue.use(
  VueGtagPlugin,
  {
    bootstrap: false,
    appName: 'Pleased',
    pageTrackerScreenviewEnabled: true,
  },
  router
);

const pinia = createPinia();

//#region Maintenance Mode
async function setupMaintenanceService() {
  const maintenanceModeConfig = env.get('maintenanceMode');

  const enabled = maintenanceModeConfig?.enabled;
  if (!enabled) return;
  const maintenanceWindow = maintenanceModeConfig?.window;
  if (!maintenanceWindow) return;
  // Just initialize the lib, it will be used in other places.
  // If this is already initialized, then the following is a no-op.
  await setupMaintenanceLib([maintenanceWindow]);
}

setupMaintenanceService().catch((error) => {
  logger.error('[MAINTENANCE_SERVICE] Failed to setup maintenance service:', { error: parseErrorMessage(error) });
  captureEventException(error, ErrorTrackingEvent.MaintenanceSetup);
});
//#endregion

window.VMPY = new Vue({
  router,
  store,
  render: (h) => h(Bridge.isLegacyBridge ? App : ModernApp),
  i18n: Locale.i18n,
  pinia,
}).$mount('#app');

// this is for $dialog
window.h = window.VMPY.$createElement;

// Set header for pleased API when language changes.
Locale.addListener(({ current: acceptLanguage }) => PleasedApi.setConfig({ acceptLanguage }), true);
